import {
  ADD_BILLINGCONSOLIDATEDINVOICE,
  ADD_BILLINGGENERATEINVOICE,
  ADD_BILLINGREQUESTAPPROVAL,
  GET_BILLINGCONSOLIDATEDINVOICE,
  GET_BILLINGEXTRACHARGECALCULATION,
  GET_BILLINGINVOICEDETAILS,
  GET_BILLINGLIST,
  GET_BILLINGPRICEDETAILS,
  GET_CONSOLIDATE_INVOICE_MATRIX,
  GET_FINAL_INVOICE,
  ADD_BILLINGREQUESTAPPROVALLINK
} from "resources/actionTypes";

const initialState = {
  billingList: [],
  loading: false,
};

const initialBillingInvoiceState = {
  bilingInvoiceDetails: "",
  loading: false,
};

const initialBillingApprovalState = {
  bilingApprovalRequest: "",
  loading: false,
};

const initialConsolidatedInvoiceState = {
  bilingConsolidatedInvoice: "",
  loading: false,
};

const initialBillingGenerateInvoiceState = {
  billingInvoice: "",
  loading: false,
};

const initialBillingPriceDetailsState = {
  bilingPriceDetails: "",
  loading: false,
};

const initialBillingChargesCalculationState = {
  chargesCalculations: "",
  loading: false,
}
const intialConsildateInvoiceMatrixState = {
  consolidateInvoiceMatrix:"",
  loading:false,
}
const intialFinalInvoiceState = {
  getFinalInvoice:"",
loading:false,
}

const initialBillingApprovalLinkState = {
  bilingApprovalRequestLink: "",
  loading: false,
};

export const getBillingList = (state = initialState, action) => {
  switch (action.type) {
    case GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGLIST.GET_BILLINGLIST_SUCCESS:
      return {
        ...state,
        billingList: action.billingList,
        loading: false,
      };
    case GET_BILLINGLIST.GET_BILLINGLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_BILLINGLIST.GET_BILLINGLIST_CLEARED:
      return {
        ...state,
        loading: false,
        billingList: ""
      };
    default:
      return state;
  }
};

export const getBillingInvoiceDetails = (state = initialBillingInvoiceState, action) => {
  switch (action.type) {
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_SUCCESS:
      return {
        ...state,
        bilingInvoiceDetails: action.billingInvoiceDetails,
        loading: false,
      };
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingGenerateInvoice = (state = initialBillingGenerateInvoiceState, action) => {
  switch (action.type) {
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_SUCCESS:
      return {
        ...state,
        billingInvoice: action.billingInvoice,
        loading: false,
      };
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingChargesCalculations = (state = initialBillingChargesCalculationState, action) => {
  switch (action.type) {
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_SUCCESS:
      return {
        ...state,
        chargesCalculations: action.chargesCalculations,
        loading: false,
      };
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingPriceDetails = (state = initialBillingPriceDetailsState, action) => {
  switch (action.type) {
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_SUCCESS:
      return {
        ...state,
        bilingPriceDetails: action.billingPriceDetails,
        loading: false,
      };
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};


export const addBillingRequestApproval = (
  state = initialBillingApprovalState,
  action
) => {
  switch (action.type) {
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_SUCCESS:
      return {
        ...state,
        bilingApprovalRequest: action.billingRequest,
        loading: false,
      };
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const addBillingConsolidatedInvoice = (
  state = initialConsolidatedInvoiceState,
  action
) => {
  switch (action.type) {
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS:
      return {
        ...state,
        bilingConsolidatedInvoice: action.billingConsolidatedRequest,
        loading: false,
      };
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingConsolidatedInvoiceDetails = (
  state = initialConsolidatedInvoiceState,
  action
) => {
  switch (action.type) {
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS:
      return {
        ...state,
        bilingConsolidatedInvoice: action.billingConsolidatedInvoice,
        loading: false,
      };
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getConsolidateInvoiceMatrix = (
  state = intialConsildateInvoiceMatrixState,
  action
) => {
  switch(action.type){
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED:
      return {
        ...state,
        loading:true,
      };
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS:
      return{
        ...state,
        consolidateInvoiceMatrix:action.consolidateInvoiceMatrix,
        loading:false,
      };
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_FAILED:
      return {
        ...state,
        loading:false,
        error:action.message
      }
      default:
        return state;
  }
}

export const getFinalInvoice = (
  state = intialFinalInvoiceState,
  action
) => {
  switch(action.type){
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED:
      return{
        ...state,
        loading:true,
      };
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_SUCCESS:
      return{
        ...state,
        loading:false,
        getFinalInvoice:action.finalInvoiceData
      }
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_FAILED:
      return{
        ...state,
        loading:false,
        error:action.message
      }
      case GET_FINAL_INVOICE.GET_FINAL_INVOICE_CLEARED:
      return {
        ...state,
        loading: false,
        getFinalInvoice: ""
      };
      default:
        return state;
  }
}

// Billing Request Approval Link
export const addBillingRequestApprovalLink = (
  state = initialBillingApprovalLinkState,
  action
) => {
  switch (action.type) {
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS:
      return {
        ...state,
        bilingApprovalRequestLink: action.billingRequest,
        loading: false,
      };
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};